import Vue from 'vue';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import './custom.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use( BootstrapVue );
Vue.use( IconsPlugin );
